<template>
	<div>
		<el-drawer class="commission-plan-drawer" title="商品信息" size="820px" :append-to-body="true" :visible.sync="visible" @closed="reset">
			<div class="goods-info" v-if="Object.keys(info).length">
				<img class="goods-img" :src="info.product_pic" alt="" />
				<div class="ml-8">
					<div class="flex flex-align-center">
						<platform-icon :platformId="info.platform_id"></platform-icon>
						<div class="fz-12 yx-color-text-primary goods-title ml-4 mr-4" style="font-weight: bold">{{ info.product_name }}</div>
						<ID-tag style="color: #86909c !important" :id="info.third_product_id" />
					</div>
					<div class="flex flex-align-center mt-4">
						<div class="tag-second" v-if="info.product_type_name">{{ info.product_type_name }}</div>
						<div class="ml-4 empty-tag mr-4" v-if="info.brand_name">{{ info.brand_name }}</div>
						<div class="tag-classify" v-if="info.cate_name">{{ info.cate_name }}</div>
					</div>
					<div class="flex flex-align-center mt-4">
						<div class="flex flex-align-center">
							<div class="mr-4 fz-12 store-name">店铺：{{ info.shop_name || '-' }}</div>
							<ID-tag style="color: #86909c !important" :id="info.shop_id"></ID-tag>
						</div>
						<div class="flex flex-align-center ml-8" v-if="Object.keys(info.shop_scores).length">
							<div class="fz-12" style="color: #4e5969">评分：</div>
							<div class="fz-12 yx-color-text-primary" style="font-weight: bold">{{ info.shop_scores.shop_score }}</div>
						</div>
					</div>
					<div class="mt-4 flex flex-align-center">
						<div class="flex flex-align-center">
							<div class="fz-12 yx-color-text-primary">现售价</div>
							<div class="ml-4 fz-12" style="color: #4e5969">{{ info.live_price | formatPrice }}</div>
						</div>
						<div class="flex flex-align-center ml-24">
							<div class="fz-12 yx-color-text-primary">可分配服务费率</div>
							<div class="ml-4 fz-12" style="color: #4e5969">{{ info.assigned_service_rate || '-' }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="commisson-plan-content">
				<div class="title fz-16 yx-color-text-primary" style="font-weight: bold; margin-top: 24px">佣金计划</div>
				<div class="mt-16 flex flex-align-center mb-24">
					<el-button type="primary" @click="handleSyncCommissionPlan">同步计划</el-button>
					<el-button @click="addPlan()" v-if="$auth.hasPermi('shopManage:add-commission-plan')" style="margin-left: 16px">添加计划</el-button>
				</div>
				<multi-table v-loading="loading" :columns="columns" :list="list" :stickyHeader="false" :showPager="false">
					<empty ref="empty" slot="empty"></empty>
				</multi-table>
			</div>
		</el-drawer>
		<!--添加佣金计划-->
		<commissionPlanDialog @refresh="getList" ref="commissionPlanDialog"></commissionPlanDialog>
	</div>
</template>
<script>
import debounce from 'lodash/debounce';
import IDTag from '@/components/ui/IDTag';
import getColums from './commissPlanColumns';
import commissionPlanDialog from './commissionPlanDialog.vue';
import { copyFun } from '@/utils/common';
import { getCommissionList, syncCommissionPlan } from '@/api/shopManage';
import { ksAuditStatusType } from '@/utils/dataMap';
import { uniq } from 'lodash';

export default {
	name: 'commissionPlanDrawer',
	data() {
		return {
			visible: false,
			list: [],
			info: {},
			loading: false,
		};
	},
	components: {
		IDTag,
		commissionPlanDialog,
	},
	computed: {
		columns() {
			return getColums(this);
		},
	},
	methods: {
		reset() {
			this.visible = false;
			this.$emit('refresh');
		},
		show(info) {
			this.info = info;
			this.list = [];
			this.getList();
			this.visible = true;
		},
		async getList() {
			try {
				this.loading = true;
				const { data, code } = await getCommissionList({ productId: this.info.product_id });
				if (code === 0) {
					this.list = data.list.map(item => ({
						...item,
						operations: this.getButtons(item),
					}));
				}
			} finally {
				this.loading = false;
			}
		},
		getButtons(item) {
			const toBeReviewed = item.status == ksAuditStatusType.toBeReviewed;
			const copyLink = {
				label: '复制链接',
				type: 'text',
				classtype: 2,
				show: toBeReviewed,
				click: row => this.$copy(item.headSupplierItemLink),
			};
			return [copyLink].filter(item => item.show);
		},
		addPlan() {
			let info = {
				authorityId: this.info.authority_id,
				productId: this.info.product_id,
				thirdProductId: this.info.third_product_id,
				cooperatePlanId: this.info.origin_activity_id,
				shopId: this.info.shop_id,
				assignedServiceRate: this.info.assigned_service_rate,
				originServiceRate: parseInt(this.info.origin_service_rate) ? (parseInt(this.info.origin_service_rate) / 100).toFixed(2) : 0,
			};
			console.log(this.$refs);
			this.$refs.commissionPlanDialog.show(info);
		},
		handleSyncCommissionPlan: debounce(async function () {
			try {
				this.loading = true;
				const { code } = await syncCommissionPlan({
					cooperatePlanIds: this.info.origin_activity_id ? [this.info.origin_activity_id] : [],
					authorityId: this.info.authority_id,
					productId: this.info.product_id,
				});
				if (code === 0) {
					this.$message.success('同步成功');
					this.getList();
				}
			} finally {
				this.loading = false;
			}
		}, 300),
	},
};
</script>
<style lang="less" scoped>
.goods-img {
	width: 84px;
	height: 84px;
	border-radius: 4px;
}
.commission-plan-drawer {
	.el-drawer__header {
		font-size: 16px;
		font-weight: 500;
		color: #1a2029;
		padding: 20px 24px 20px 24px;
	}
	/deep/ .el-drawer__body {
		padding: 16px 24px 24px 24px;
	}
	.goods-info {
		display: flex;
		margin-bottom: 24px;
		.goods-name {
			font-size: 14px;
			font-weight: 400;
		}
		.goods-title {
			max-width: 500px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.copy-link-content {
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 16px;
			height: 16px;
			background: #f2f3f5;
			border-radius: 3px;
		}
		.tag-second,
		.tag-classify {
			font-size: 10px;
			padding: 1px 4px 1px 4px;
			border-radius: 3px;
			border: 1px solid #e5e6eb;
			background: #f2f3f5;
			color: #4e5969;
		}
		.empty-tag {
			width: 18px;
			height: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(255, 247, 232, 1);
			border: 1px solid rgba(255, 228, 186, 1);
			border-radius: 2px;
			font-size: 10px;
			color: #d25f00;
		}
		.store-name {
			color: #86909c;
		}
	}
}
</style>